import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShoppingBag, Store } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { BRAND } from "../constants/brand";

export default function RoleSelect() {
  const { setRole } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const pick = async (role) => {
    setBusy(true);
    try {
      const user = await setRole(role);
      toast.success(`You're signed in as a ${role}`);
      nav(role === "vendor" ? "/vendor/dashboard" : "/customer/dashboard");
    } catch { toast.error("Please try again"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-2xl rounded-xl border border-neutral-200 bg-white p-8 shadow-sm">
        <img src={BRAND.logo} alt="EarlyPrint" className="mx-auto h-14 w-14 rounded-full" />
        <h2 className="mt-4 text-center font-display text-3xl font-bold" data-testid="roleselect-title">Almost there — how are you using EarlyPrint?</h2>
        <p className="mt-2 text-center text-sm text-neutral-600">You can switch anytime later from your profile.</p>

        <div className="mt-8 grid gap-4 md:grid-cols-2">
          <button disabled={busy} onClick={() => pick("customer")} className="group rounded-lg border border-neutral-200 p-6 text-left transition-transform hover:-translate-y-1 hover:border-neutral-900" data-testid="role-customer">
            <ShoppingBag size={22} className="text-lime-500" />
            <h3 className="mt-3 font-display text-xl font-bold">I want to order prints</h3>
            <p className="mt-1 text-sm text-neutral-600">Get live quotes from vendors, escrow-safe payments, and live tracking.</p>
          </button>
          <button disabled={busy} onClick={() => pick("vendor")} className="group rounded-lg border border-neutral-200 p-6 text-left transition-transform hover:-translate-y-1 hover:border-neutral-900" data-testid="role-vendor">
            <Store size={22} className="text-lime-500" />
            <h3 className="mt-3 font-display text-xl font-bold">I'm a print shop / vendor</h3>
            <p className="mt-1 text-sm text-neutral-600">Receive pre-paid orders on WhatsApp. No lead fees. No upfront cost.</p>
          </button>
        </div>
      </div>
    </div>
  );
}
